import React from "react"
import { InputFieldInterface } from "../../const"

const InputField = ({ field, label, state, dispatch, readOnly = false, type = "select", array = [] }: InputFieldInterface) => {
    // const captureInput = (e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>) => {
    //     const input = (e.target as HTMLSelectElement).value
    //     const validation = state[field].validationFn(input)
    //     if (input && !validation) dispatch({ type: "set-value", payload: [field, input] })
    //     else dispatch({ type: "set-error", payload: [field, validation] })
    // }

    return (
        <fieldset className={`input-field ${state[field]["err"] ? "invalid" : ""}`}>
            <label htmlFor={field}>
                {label} {state[field]["required"] ? "*" : ""}
            </label>
            <select
                id={field}
                data-testid={field}
                // defaultValue={defaultValue}

                onChange={(e) => { 
                    const input = e.target.value
                    const validation = state[field].validationFn(input)
                    if (input && !validation) dispatch({ type: "set-value", payload: [field, input] })
                    else
                        dispatch({
                            type: "set-error",
                            payload: [field, validation],
                        })
                }}
                onFocus={() => {
           
                    if (state[field]["err"]) {
                        dispatch({
                            type: "set-error",
                            payload: [field, ""],
                        })
                    }
                }}>
                {array.length > 0 &&
                    array.map((item, index) => (
                        <option key={index} value={item.code}>
                            {item.name}
                        </option>
                    ))}
            </select>
            <div className="field-error">{state[field]["err"]}</div>
        </fieldset>
    )
}

export default InputField